import {useCallback} from 'react'
import {useInvalidateOnAliveUpdate} from '@github-ui/use-invalidate-on-alive-update'
import {useChangeGroupsDataQueryKey} from '../page-data/loaders/use-change-groups-data'

type ChangeGroupsAliveData = {wait?: number; base_commit_oid?: string; head_commit_oid?: string}

export function useChangeGroupsLiveUpdates(
  channel: string,
  baseSha: string | undefined,
  headSha: string | undefined,
): void {
  const queryKey = useChangeGroupsDataQueryKey(headSha, baseSha)

  const filter = useCallback(
    (data: ChangeGroupsAliveData) => data.base_commit_oid === baseSha && data.head_commit_oid === headSha,
    [baseSha, headSha],
  )

  useInvalidateOnAliveUpdate(channel, queryKey, {filter})
}
